import { Injectable, inject } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { DsmApiResponseDataDto } from 'src/app/shared/models/dsm-api-call.model';
import { IncomingTopicsActions } from '.';
import { DefaultViewFilterSto } from '../../../shared/models/default-view-filter.model';
import { AcknowledgeRequestDto, IncomingTopicsSto } from '../models/incoming-topic.model';
import { IncomingTopicsService } from '../services/incoming-topics.service';

@Injectable()
export class IncomingTopicsEffects {
  private actions$ = inject(Actions);
  private incomingTopicsService = inject(IncomingTopicsService);

  acknowledgeIncomingTopic = createEffect(() =>
    this.actions$.pipe(
      ofType(IncomingTopicsActions.ACKNOWLEDGE),
      map((action: IncomingTopicsActions.AcknowledgeIncomingTopics) => action?.payload),
      mergeMap(payload => {
        const requestBody: AcknowledgeRequestDto = {
          subEventIds: payload.subEventIds,
          dismissed: payload?.dismissed,
        };

        return this.incomingTopicsService.acknowledgeIncomingTopic(payload.aggregateId, requestBody).pipe(
          map((_: DsmApiResponseDataDto) => {
            return new IncomingTopicsActions.AcknowledgeIncomingTopicsSuccessful(payload);
          })
        );
      })
    )
  );

  loadIncomingTopicsPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IncomingTopicsActions.LOAD_PAGE),
      map((action: IncomingTopicsActions.LoadIncomingTopicsPage) => action?.payload),
      mergeMap((payload: { viewId: string; viewFilter: DefaultViewFilterSto; sort: Sort; offset: number }) => {
        return this.incomingTopicsService
          .loadIncomingTopicsFiltered(payload?.viewFilter, ['Machine', 'Workshop', 'Customer'], payload?.sort, payload?.offset)
          .pipe(
            map((res: DsmApiResponseDataDto) => {
              return new IncomingTopicsActions.LoadIncomingTopicsPageSuccessful({
                viewId: payload?.viewId,
                topics: res?.data?.map(dto => new IncomingTopicsSto(dto)),
                topicsTotalCount: res?.meta?.pagination?.total,
                related: res?.related,
                viewFilter: payload?.viewFilter,
                offset: payload?.offset,
              });
            })
          );
      })
    )
  );
}
